import React from "react";
import Style from "./ProgrammeWhyChoose.module.css";

interface WhyChooseCard {
  id: number;
  title: string;
  description: string;
}

interface WhyChooseSection {
  id?: number;
  title?: string;
  description?: string;
  hide_section?: boolean;
  items?: WhyChooseCard[];
  cards?: WhyChooseCard[];
}

interface ProgrammeWhyChooseProps {
  data?: WhyChooseSection | WhyChooseCard[];
  isUgpg?: boolean;
}

const ProgrammeWhyChoose: React.FC<ProgrammeWhyChooseProps> = ({
  data,
  isUgpg,
}) => {
  const sectionData: WhyChooseSection | undefined = Array.isArray(data)
    ? { items: data }
    : data;

  if (
    !sectionData ||
    sectionData.hide_section === true
  ) {
    return null;
  }

  const cards = sectionData.items ?? sectionData.cards ?? [];

  return (
    <div className={isUgpg ? Style.ugpgGlobalRow : Style.schoolGlobalRow}>
     
        {sectionData?.title && <h2>{sectionData.title}</h2>}
        {sectionData?.description && <p>{sectionData.description}</p>}

        <div className="row">
          <>
            {cards?.map((item) => (
              <div
                className={`col-md-6 ${Style.rowSpaceBottom}`}
                key={item?.id}
              >
                <div className={Style.schoolGlobalContent}>
                  <div
                    className={isUgpg ? Style.borderBlack : Style.borderYellow}
                  ></div>
                  <strong>{item?.title}</strong>
                  <p>{item?.description}</p>
                </div>
              </div>
            ))}
          </>
        </div>
      </div>
    
  );
};

export default ProgrammeWhyChoose;
